import React, { useState } from "react"
import clsx from "clsx"
import TextInputField from "../textInput"
import { useLanguage } from "@languages/index"

interface Props {
  index?: number
  guide?: any
  description?: string

  isDefault?: any
  onChangeText?: any
  className?: string
  onClick?: any
  onDelete?: any
}

const GuideImage = (props: Props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.component.guideImage }

  let className = clsx(
    "guide-image relative flex flex-col justify-center items-center cursor-pointer -z-[1]",
    `${props.className ? props.className : ""}`
  )

  const renderDeleteButton = () => {
    if (props.isDefault) {
      return null
    }

    return (
      <div
        className="absolute cursor-pointer"
        style={{
          top: 0,
          right: 0,
          zIndex: 3,
          backgroundColor: "black",
        }}
        onClick={() => {
          console.log("clicked")
          props.onDelete ? props.onDelete(props.guide) : null
        }}
      >
        <img className="p-1" src={"/assets/icons/close-white.svg"} />
      </div>
    )
  }

  const renderDescriptionInput = () => {
    if (props.isDefault) {
      return null
    }

    return (
      <div className="mt-5">
        <TextInputField
          key={`guide-input-${props.index}`}
          placeholder={languageTexts.one_line_desc}
          value={props.description}
          onChangeText={props.onChangeText ? props.onChangeText : null}
        />
      </div>
    )
  }

  return (
    <div className="flex flex-col relative">
      {renderDeleteButton()}

      <div
        className={className}
        style={{
          border: "1px solid #E8E8E8",
        }}
      >
        <img
          className="object-cover"
          src={`${props.guide.url}`}
          style={{
            width: "100%",
            height: "100%",
          }}
        />
      </div>
      {renderDescriptionInput()}
    </div>
  )
}

export default GuideImage
